import {
  backButton,
  initData,
  init as initSDK,
  mainButton,
  miniApp,
  setDebug,
  settingsButton,
  themeParams,
  viewport,
} from '@tma.js/sdk-react'

export const init = (isDebug = false) => {
  setDebug(isDebug)
  initSDK()

  backButton.mount.ifAvailable()
  mainButton.mount.ifAvailable()
  settingsButton.mount.ifAvailable()
  initData.restore()

  if (miniApp.mount.isAvailable()) {
    themeParams.mount()
    miniApp.mount()
    themeParams.bindCssVars()
  }

  if (viewport.mount.isAvailable()) {
    viewport.mount().then(() => {
      viewport.bindCssVars()
      viewport.expand()
    })
  }
}
